import { Command } from '@ckeditor/ckeditor5-core';
export default class InsertCompareResumesCommand extends Command {
    execute() {
        this.editor.model.change((writer) => {
            this.editor.model.insertContent(createCompareResumes(writer));
        });
    }
    refresh() {
        this.isEnabled = true;
    }
}
function createCompareResumes(writer) {
    const compareResumes = writer.createElement('compareResumes');
    const compareResumesCaption = writer.createElement('compareResumesCaption');
    writer.append(compareResumesCaption, compareResumes);
    return compareResumes;
}
